import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'country-select',
  template: `
    <ng-container [formGroup]="parent">
      <ng-select 
        class="country-select ng-select"
        [formControlName]="controlName"
        [items]="countries"
        [multiple]="false"
         bindLabel="label"
         bindValue="value"
         id="country"
         (change)="handleChange($event)">
        <ng-template ng-label-tmp let-item="item">
          <div class="flag-{{item?.value.toLowerCase()}}" [ngClass]="label ? 'flag-small' : 'flag'"></div>
          <span *ngIf="label">{{item?.label}}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          <div class="flag-{{item?.value.toLowerCase()}}" [ngClass]="label ? 'flag-small' : 'flag'"></div>
          <span class="count-templete">{{item?.label}}</span>
        </ng-template>

      </ng-select>
    </ng-container>
  `,
  styleUrls: ['./country-select.component.scss']
})

export class CountrySelectComponent {
  @Input() countries: Array<{value: string; label: string}>;
  @Input() parent: FormGroup;
  @Input() label: boolean;
  @Input() controlName: string;
  @Output() changeSelect: EventEmitter<string> = new EventEmitter();

  constructor() {}

  // ngOnInit() {
  //   this.countries = this.shipmentService.getCountryRules();
  //   if(!this.countries) {
  //     this.shipmentService.getInitialData()
  //       .subscribe((data: InitInformation) => {
  //         this.countries = this.shipmentService.getCountryRules();
  //       });
  //   }
  // }

  handleChange(event) {
    this.changeSelect.emit(event.value);
    const country = this.countries.find(({value}) =>  value === event.value);
    const countryLabel: string = country && country.label;
    this.parent.get('country').setValue(countryLabel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/country-select/country-select.component.ts